import type { FilePreviewHandler, FilePreviewProps } from "./file-preview-registry"

// Inject a small bridge so links inside the sandboxed preview open in a new
// browser tab instead of navigating (or being blocked inside) the iframe.
// The iframe is sandboxed without allow-same-origin, so it is cross-origin to
// the parent; we therefore forward clicks to the parent via postMessage and
// let the parent perform window.open.
const LINK_BRIDGE = `<script>
(function () {
  if (window.__zdLinkBridgeInstalled) return
  window.__zdLinkBridgeInstalled = true

  function openInParent(url) {
    try {
      window.parent.postMessage({ __zdPreviewOpen: true, url: url }, "*")
    } catch (e) {}
  }

  // Intercept in-page link clicks and ask the parent to open a new tab.
  document.addEventListener(
    "click",
    function (event) {
      var anchor = event.target && event.target.closest ? event.target.closest("a[href]") : null
      if (!anchor) return
      var href = anchor.getAttribute("href") || ""
      if (!href || href.charAt(0) === "#" || /^javascript:/i.test(href)) return
      event.preventDefault()
      event.stopPropagation()
      openInParent(anchor.href)
    },
    true,
  )

  // Redirect window.open inside the preview to the parent as well.
  var originalOpen = window.open ? window.open.bind(window) : null
  window.open = function (url) {
    if (url) {
      openInParent(String(url))
      return null
    }
    return originalOpen ? originalOpen.apply(window, arguments) : null
  }
})()
</script>`

function injectLinkBridge(contents: string): string {
  const bodyClose = /<\/body>/i
  if (bodyClose.test(contents)) return contents.replace(bodyClose, `${LINK_BRIDGE}</body>`)
  const htmlClose = /<\/html>/i
  if (htmlClose.test(contents)) return contents.replace(htmlClose, `${LINK_BRIDGE}</html>`)
  return contents + LINK_BRIDGE
}

export function HtmlPreview(props: FilePreviewProps) {
  const srcdoc = () => injectLinkBridge(props.contents)
  return (
    <iframe
      srcdoc={srcdoc()}
      sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
      title={props.path}
      style={{
        display: "block",
        width: "100%",
        height: `${props.viewportHeight ?? 400}px`,
        border: "none",
      }}
      onLoad={() => props.onRendered?.()}
    />
  )
}

export const htmlHandler: FilePreviewHandler = {
  extensions: ["html", "htm"],
  hasSourceToggle: true,
  render: (props) => <HtmlPreview {...props} />,
}
